var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13504_4453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50148 15.003C11.6444 15.003 15.003 11.6444 15.003 7.50148C15.003 3.35853 11.6444 0 7.50148 0C3.35853 0 0 3.35853 0 7.50148C0 11.6444 3.35853 15.003 7.50148 15.003Z",
    fill: "#2B3A67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2087 2.88541H10.179C9.85838 3.43756 9.4606 3.90659 9.13109 4.4528C8.52848 4.06689 7.86649 3.74332 6.98781 3.66614C4.69016 3.46428 2.94763 5.03166 2.47564 7.1601L2.4133 7.92005C2.35986 10.6303 5.37589 12.9933 8.19897 11.791C7.99414 11.2567 7.85759 10.663 7.59339 10.1791C5.85976 10.8233 4.18848 9.62696 4.15286 8.0002C4.10833 5.84207 6.35254 4.70513 8.09507 5.86879C7.79822 6.45359 7.29357 6.97309 7.04421 7.49852C8.88173 7.62616 10.7964 7.84287 12.5894 7.91708C11.8117 6.22501 11.0102 4.5567 10.2087 2.88245V2.88541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13504_4453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePosition);
export default __webpack_public_path__ + "static/media/changePosition.18b716d7a90dfbec99f287f8dba14f25.svg";
export { ForwardRef as ReactComponent };